$(document).ready(function () {
var h=$("#myHeader").outerHeight();
// $("#MainContent").css("margin-top",h+"px");
document.querySelectorAll('.t4s-product').forEach(wrapper => {
  const toggle = wrapper.querySelector('.auto-refill-toggle');
  const plans = wrapper.querySelector('.auto-refill-plans');
  const selectedUI = wrapper.querySelector('.selected-plan');
  const pill = wrapper.querySelector('.selected-pill');
  const sid = wrapper.querySelector(".selling-plan");
  // const priceNew = wrapper.querySelector('.price-new');
  // const priceOld = wrapper.querySelector('.price-old');
  if (toggle) {
  toggle.addEventListener('click', () => {
    plans.style.display = 'block';
  });
  }
    if (selectedUI) {

  selectedUI.addEventListener("click",()=>{
      plans.style.display = 'block';
  });
    }
  if(plans){
    plans.querySelectorAll('label').forEach(label => {
      label.addEventListener('click', () => {
        const isSelected = label.classList.contains('selected');
        plans.querySelectorAll('label').forEach(l => l.classList.remove('selected'));

          // const text = label.innerText.trim();
          // // const price = label.dataset.price;
          // // const compare = label.dataset.compare;
          // pill.textContent = text;
          // // priceNew.textContent = `${price}`;
          // // priceOld.textContent = `${compare}`;

          // selectedUI.style.display = 'block';
          // toggle.style.display = 'none';
          // plans.style.display = 'none';
          // wrapper.classList.add('has-selection');
          if (!isSelected) {
              label.classList.add('selected'); // select clicked label
              const text = label.innerHTML.trim();
              pill.innerHTML = text;
              selectedUI.style.display = 'block';
              toggle.style.display = 'none';
              wrapper.classList.add('has-selection');
              plans.style.display = 'none';
              sid.value=label.dataset.sid;
            } else {
              // If it was already selected, deselect and show toggle
              selectedUI.style.display = 'none';
              toggle.style.display = 'block';
              wrapper.classList.remove('has-selection');
              plans.style.display = 'none';
              sid.value='';
            }
      });
    });
  }
});

  document.querySelectorAll('.seg-wrapper').forEach(wrapper => {
    const checkbox = wrapper.querySelector('.seg-input');
    // const noBtn = wrapper.querySelector('.no-liner-btn');
    const upsellwrap = wrapper.querySelector('.seg-card');
    const subscribeBtn = wrapper.querySelector(".seg-sub");
    const subBox = wrapper.querySelector(".seg-subscription");
    const priceEl = wrapper.querySelector('.seg-price');
    const radios = wrapper.querySelectorAll('input[type="radio"]');
    const planSelect = wrapper.querySelector('.addon-plan-select-box');
    function updatePrice() {
      const selectedRadio = wrapper.querySelector('input[type="radio"]:checked');
      if (selectedRadio.value === 'one-time') {
        const price = selectedRadio.dataset.price;
        priceEl.textContent = `+ ${price}`;
        planSelect.style.display = 'none';
      }
      if (selectedRadio.value === 'subscribe') {
        planSelect.style.display = 'inline-block';
        const selectedPlan = planSelect.options[planSelect.selectedIndex];
        const price = selectedPlan.dataset.price;
        priceEl.textContent = `+ ${price}`;
      }
    }
  if (!checkbox) return;
  function syncButtonState() {
    if (checkbox.checked) {
      upsellwrap.classList.remove('is-disabled');  
      // noBtn.classList.add('is-disabled');
      // noBtn.classList.remove('actived');
    } else {
      upsellwrap.classList.add('is-disabled');
      // noBtn.classList.remove('is-disabled');
    //  noBtn.classList.add('actived');
    }
  }
  const select = wrapper.querySelector('.addon-plan-select-box');

  function sync() {
    const checked = wrapper.querySelector('input[value="subscribe"]:checked');
    select.style.display = checked ? 'block' : 'none';
  }

  radios.forEach(r => r.addEventListener('change', sync));
  sync(); 

  radios.forEach(radio => {
      radio.addEventListener('change', updatePrice);
    });

    // Plan change
    if (planSelect) {
      planSelect.addEventListener('change', updatePrice);
    }

    updatePrice();

    if (subscribeBtn) {
    subscribeBtn.addEventListener("click", e => {
      e.stopPropagation();
      subscribeBtn.style.display= 'none';
      subBox.style.display = "flex";
    });
  }

  // syncButtonState();

  checkbox.addEventListener('change', syncButtonState);

  // noBtn.addEventListener('click', e => {
  //   e.stopPropagation();
  //   checkbox.checked = false;
  //   checkbox.dispatchEvent(new Event('change'));
  // });
});

document.querySelector('.add-on-present')?.addEventListener('click', function () {
  const items = [];
  document.querySelectorAll('.seg-input:checked').forEach(checkbox => {
   console.log("this",checkbox);
    const addonItem = checkbox.closest('.seg-card');
    if (!addonItem) return;

    const variantId = checkbox.dataset.variantId;
    if (!variantId) return;
    const subscribeRadio = addonItem.querySelector('input[type="radio"][value="subscribe"]:checked');
    const planSelect = addonItem.querySelector('.addon-plan-select-box');
    let item = {
      id: variantId,
      quantity: 1
    };
    if (subscribeRadio && planSelect?.value) {
      item.selling_plan = planSelect.value;
    }
    items.push(item);
  });
  if (!items.length) return;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items })
  })
  .then(r => r.json())
  .then(() => {
    T4SThemeSP.Cart.getToFetch(true);
    const trigger = document.querySelector('[data-drawer-options*="#t4s-menu-drawer"]');
    if (trigger) {
      T4SThemeSP.Drawer.opend($(trigger));
    }
    console.log("item",items);
  })
  .catch(console.error);
});

// Design 1
// document.querySelectorAll('.addon-item').forEach(item => {
//   const subscribeWrap = item.querySelector('.addon-subscribe');
//   const radios = subscribeWrap.querySelectorAll('input[type="radio"]');
//   const planSelect = item.querySelector('.addon-plan-select');

//   // Open on click of collapsed bar
//   subscribeWrap.addEventListener('click', e => {
//     if (!subscribeWrap.classList.contains('is-open')) {
//       subscribeWrap.classList.add('is-open');
//     }
//   });

//   radios.forEach(radio => {
//     radio.addEventListener('change', () => {
//       if (radio.value === 'subscribe') {
//         subscribeWrap.classList.add('is-subscribe');
//         planSelect.style.display = 'block';
//       } else {
//         subscribeWrap.classList.remove('is-subscribe');
//         planSelect.style.display = 'none';
//       }
//     });
//   });
// });

// Old Design  
//   function initAddonSubscription(context = document) {
//   context.querySelectorAll('.addon-item').forEach(item => {
//     if (item.dataset.subInit) return;
//     item.dataset.subInit = "1";

//     const planWrap = item.querySelector('.addon-plan-select');
//     if (!planWrap) return;

//     item.addEventListener('change', e => {
//       if (e.target.type !== 'radio') return;

//       planWrap.style.display =
//         e.target.value === 'subscribe' ? 'block' : 'none';
//     });
//   });
// }
// document.addEventListener('click', function (e) {
//   const btn = e.target.closest('.addon-add-btn');
//   if (!btn) return;

//   e.preventDefault();

//   const item = btn.closest('.addon-item');
//   if (!item) return;

//   const variantId = parseInt(item.querySelector('.vid')?.value);
//   if (!variantId) return;

//   const purchaseType =
//     item.querySelector('input[type="radio"]:checked')?.value || "onetime";

//   const planBox = item.querySelector('.addon-plan-select-box');
//   const sellingPlan =
//     purchaseType === 'subscribe' && planBox ? planBox.value : null;

//   const payload = {
//     items: [{
//       id: variantId,
//       quantity: 1,
//       ...(sellingPlan && { selling_plan: sellingPlan })
//     }]
//   };

//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(payload)
//   })
//     .then(r => r.json())
//     .then(() => {
//       T4SThemeSP.Cart.getToFetch(true);

//       const trigger = document.querySelector('[data-drawer-options*="#t4s-menu-drawer"]');
//       if (trigger) T4SThemeSP.Drawer.opend($(trigger));
//     })
//     .catch(console.error);
// });


// const addonObserver = new MutationObserver(mutations => {
//   mutations.forEach(m => {
//     m.addedNodes.forEach(node => {
//       if (!(node instanceof HTMLElement)) return;

//       if (node.matches('.addon-item')) {
//         initAddonSubscription(node.parentNode);
//       }

//       node.querySelectorAll?.('.addon-item').forEach(() => {
//         initAddonSubscription(node);
//       });
//     });
//   });
// });

// addonObserver.observe(document.body, {
//   childList: true,
//   subtree: true
// });

// // Initial run
// initAddonSubscription();


  
    //  document.querySelectorAll('.addon-item').forEach(item => {
    //   const radios = item.querySelectorAll('input[type="radio"]');
    //   const planSelect = item.querySelector('.addon-plan-select');
    //   if (radios.length && planSelect) {
    //     radios.forEach(radio => {
    //       radio.addEventListener('change', () => {
    //         if (radio.value === 'subscribe') {
    //           planSelect.style.display = 'block';
    //         } else {
    //           planSelect.style.display = 'none';
    //         }
    //       });
    //     });
    //   }
    // });

    // document.querySelectorAll('.addon-add-btn').forEach(btn => {
    //   btn.addEventListener('click', function() {
    //     const parent = this.closest('.addon-item');
    //     // let variantId = parent.dataset.variant;
    //     let variantSelector = parent.querySelector('.vid').value;
    //     const purchaseType = parent.querySelector('input[type="radio"]:checked')?.value || "onetime";
    //     const planSelect = parent.querySelector('.addon-plan-select-box');
    //     const sellingPlanId = (purchaseType === "subscribe" && planSelect) ? planSelect.value : null;
    //     let variantId=parseInt(variantSelector);
    //     console.log(variantSelector);
    //     console.log("vv",parent.querySelector('.vid'));
    //     let formData = {
    //       items: [{
    //         id: variantId,
    //         quantity: 1
    //       }]
    //     };

    //     if (sellingPlanId) {
    //       formData.items[0].selling_plan = sellingPlanId;
    //     }
    //     console.log(formData);

    //     fetch('/cart/add.js', {
    //       method: 'POST',
    //       headers: { 'Content-Type': 'application/json' },
    //       body: JSON.stringify(formData)
    //     })
    //     .then(res => res.json())
    //     .then(data => {
    //       console.log("Added to cart:", data);
    //       T4SThemeSP.Cart.getToFetch(true); // reload + open mini cart

    //       var cartTrigger = document.querySelector('[data-drawer-options*="#t4s-menu-drawer"]');
    //       console.log(cartTrigger);
    //         if (cartTrigger) {
    //           T4SThemeSP.Drawer.opend($(cartTrigger));
    //         }
    //       })
    //     .catch(err => console.error("Error:", err));
    //   });
    // });
  $(".purchase-option").change(function () {
    $(".option-card").each(function () {
      $(this).removeClass("active");
    });
    var sellingPlan = $(this)
      .closest(".option-card")
      .parent()
      .find(".selling-plan");

    var par = $(this).parent();
    var sellingPlanVal = $(this).closest(".delivery-dropdown").val();
    $(par).addClass("active");
    if ($(this).val() === "subscribe") {
      $(sellingPlan).val(sellingPlanVal);
    } else {
      $(sellingPlan).val("");
    }
  });
  $(".delivery-dropdown").change(function () {
    var price_wrap = $(this).prev();
    var selectedPrice = $(this).find("option:selected").data("price");
    console.log("Selected data-price:", selectedPrice);
    var discount_price = $(price_wrap).find(".discount-price");
    $(discount_price).html(selectedPrice);
    var sellingPlanVal = $(this).val();
    var sellingPlan = $(this).closest(".selling-plan");
    console.log("sellingplan", sellingPlan);
    $(this)
      .closest(".option-card")
      .parent()
      .find(".selling-plan")
      .val(sellingPlanVal);
  });
  $(".t4s-push-menu-btn").click(function () {
    $(".t4s-close-overlay").css("visibility", "hidden");
  });
  var m = $(".wrapper-height").outerHeight();
  $(".megamenu-wrapper").each(function () {
    $(this).css("top", m + "px");
  });
  $(".overlay-wrapper-menu").each(function () {
    $(this).css("top", m + "px");
  });

  $(".has--children.menu-has__offsets").mouseenter(function () {
    // $("#bg-img-header-desktop").addClass("unactive");
    setTimeout(function () {
      // $("#bg-img-header-desktop").addClass("unactive-image");
    }, 250);
  });
  $(".has--children.menu-has__offsets").mouseleave(function () {
    // $("#bg-img-header-desktop").removeClass("unactive");
    setTimeout(function () {
      // $("#bg-img-header-desktop").removeClass("unactive-image");
    }, 250);
  });
  function updateHeaderStyles() {
    var header = document.getElementById("myHeader");
    // var bgimg = document.getElementById("bg-img-header-desktop");
    // var bgimgMobile = document.getElementById("bg-img-header-mobile");

    if (header.classList.contains("fixed-header")) {
      header.style.backgroundImage = "none";
      header.style.backgroundColor = "#E8F2FF";
      // bgimg.style.display = "none";
      // bgimgMobile.style.display = "none";
      // bgimg.classList.add("unactive");
      // bgimgMobile.classList.add("unactive");
      setTimeout(function () {
        // bgimg.classList.add("unactive-image");
      }, 250);
    } else {
      // bgimg.style.display = "block";
      // bgimgMobile.style.height = "block";
      header.style.height = "";
      header.style.backgroundColor = "";
      // bgimg.classList.remove("unactive");
      // bgimgMobile.classList.remove("unactive");
      setTimeout(function () {
        // bgimg.classList.add("unactive-image");
      }, 250);
    }
  }
  window.addEventListener("scroll", function () {
    var header = document.getElementById("myHeader");
    var scrollPosition = window.scrollY;
    var headerHeight = header.offsetHeight;
    if (scrollPosition > 5) {
      header.classList.add("fixed-header");
    } else {
      if ($(window).outerWidth() < 1025) {
        if ($("body").hasClass("is--opend-drawer")) {
        } else {
          header.classList.remove("fixed-header");
        }
      } else {
        header.classList.remove("fixed-header");
      }
    }
    updateHeaderStyles();
  });
  updateHeaderStyles();
});

$("[data-menu-drawer]").click(function (e) {
  // var bgimgMobile = document.getElementById("bg-img-header-mobile");
  var header = document.getElementById("myHeader");
  // bgimgMobile.classList.add("unactive");
  // bgimgMobile.classList.add("unactive-image");
  var v = parseInt($("#myHeader").outerHeight());
  console.log("vv", v);
  // var topBar = parseInt($("#shopify-section-top-bar").outerHeight());
  var announcement = 0;
  if ($("#shopify-section-announcement-bar").length > 0) {
    announcement = parseInt(
      $("#shopify-section-announcement-bar").outerHeight()
    );
  }
  setTimeout(function () {}, 500);
  if ($("#myHeader").hasClass("fixed-header")) {
    $("#t4s-menu-drawer").css("top", v + "px");
    $(".t4s-drawer-menu__close").css("top", "0px");
  } else {
    v = v + announcement;
    $("#t4s-menu-drawer").css("top", v + "px");
    $(".t4s-drawer-menu__close").css("top", announcement + "px");
  }
});
$("[data-drawer-close]").click(function () {
  // var bgimgMobile = document.getElementById("bg-img-header-mobile");
  var header = document.getElementById("myHeader");
  if (header.classList.contains("fixed-header")) {
  } else {
    // bgimgMobile.classList.remove("unactive");
    setTimeout(function () {
      // bgimgMobile.classList.remove("unactive-image");
    }, 250);
  }
});

//   function updateHeaderStyles() {
//     var header = document.getElementById('myHeader');
//     if (header.classList.contains('fixed-header')) {
//         header.style.backgroundImage = 'none';
//         header.style.height = '100px';
//         header.style.backgroundColor = '#c3d4e8';
//     } else {
//         header.style.backgroundImage = 'url("https://happimess.com/cdn/shop/files/Vector_6.svg?v=1697701166&width=2160")';
//       }
// }
// window.addEventListener('scroll', function() {
//     var header = document.getElementById('myHeader');
//     var scrollPosition = window.scrollY;
//     if (scrollPosition > 100) {
//         header.classList.add('fixed-header');
//     } else {
//         header.classList.remove('fixed-header');
//     }
//     updateHeaderStyles();
// });
// updateHeaderStyles();

window.onscroll = function () {
  myFunction();
};

var stickyHeaderEl = document.getElementById("myHeader");
var sticky = stickyHeaderEl ? stickyHeaderEl.offsetTop : 0;

function myFunction() {
  if (!stickyHeaderEl) return;
  // var v = $("#myHeader").outerHeight() - 5;
  var v = parseInt($("#myHeader").outerHeight());
  // var topBar = parseInt($("#shopify-section-top-bar").outerHeight());
  var announcement = parseInt(
    $("#shopify-section-announcement-bar").outerHeight()
  );
  if (window.pageYOffset > sticky) {
    stickyHeaderEl.classList.add("fixed-header");
  } else {
    stickyHeaderEl.classList.remove("fixed-header");
  }
  if ($("#myHeader").hasClass("fixed-header")) {
    $("#t4s-menu-drawer").css("top", v + "px");
    // setTimeout(function () {
    //   // $(".bg-img-header-desktop").addClass("unactive-image");
    // }, 250);
    // $("#menu-mb__ul").css("padding-top", v);
  } else {
    v = v + announcement;
    $("#t4s-menu-drawer").css("top", v + "px");
    // $("#menu-mb__ul").css("padding-top", v);
    // setTimeout(function () {
    //   // $(".bg-img-header-desktop").removeClass("unactive-image");
    // }, 250);
  }
}
$(".overlay-wrapper-menu").hover(function () {
  $("li.is-action__hover").removeClass("is-action__hover");
  if (!$("#myHeader").hasClass("fixed-header")) {
    // $(".bg-img-header-desktop").removeClass("is-action__hover");
    setTimeout(function () {
      // $(".bg-img-header-desktop").removeClass("unactive-image");
    }, 250);
  }
});
$(".overlay-wrapper-menu").click(function () {
  $("li.is-action__hover").removeClass("is-action__hover");
  if (!$("#myHeader").hasClass("fixed-header")) {
    // $(".bg-img-header-desktop").removeClass("is-action__hover");
    setTimeout(function () {
      // $(".bg-img-header-desktop").removeClass("unactive-image");
    }, 250);
  }
});
window.onresize = function () {
  myFunction();
  var m = $(".wrapper-height").outerHeight();
  $(".megamenu-wrapper").each(function () {
    $(this).css("top", m + "px");
  });
  $(".overlay-wrapper-menu").each(function () {
    $(this).css("top", m + "px");
  });
};

$("body").on("click", "#notify_button", function (e) {
  var pid = parseInt($(this).data("pid"));
  var email = $("#notify_email").val();
  var vid = parseInt($(".t4s-product__select").val());
  if (email != "") {
    $.ajax({
      type: "POST",
      url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
      data: {
        a: "UdxXz2",
        email: email,
        variant: vid,
        platform: "shopify",
      },
      success: function (response) {
        console.log(response);
      },
      error: function (response) {
        console.log(response);
      },
    });
    $(".notify-main").hide();
    $(".thank-msg").show();
  }
});





      

  function updateSubscriptionPrices(variantPrice) {

    $('.frequency-option').each(function () {

      let labelText = $(this).find('.frequency-label').text();

      let finalPrice = variantPrice;

      // Detect discount %
      let percentMatch = labelText.match(/(\d+)% off/);

      if (percentMatch) {
        let discount = parseInt(percentMatch[1]);
        finalPrice = variantPrice - (variantPrice * discount / 100);
      }

      $(this).find('.frequency-price').text(
        T4SThemeSP.Currency.formatMoney(finalPrice) + ' / delivery'
      );

    });
  }
$(document).on("variant:changed", function (evt) {
  console.log(evt.currentVariant);
  var cvariant = evt.currentVariant;
  var coptions = cvariant.options.length;
  var cid = evt.currentVariant.id;
  var sk = "";
  console.log(coptions);

  // Update SKU first so an error in the subscription-price code below can't abort it.
  $(".v-options option").each(function () {
    if ($(this).val() == cid) {
      sk = $(this).data("sku");

      if (sk != null && sk !== "") {
        $(".t4s-sku-wrapper").css("display", "block");
        $(".t4s-sku-value").text(sk);
      } else {
        $(".t4s-sku-wrapper").css("display", "none");
      }

      var packs = $(this).data("packs");
      if (packs != null && packs !== "") {
        $(".pack-size").html(packs);
      }
    }
  });

  if (cvariant) {
    try {
      updateSubscriptionPrices(cvariant.price);
    } catch (e) {
      console.error("updateSubscriptionPrices failed", e);
    }
  }
  if (cvariant.available == true) {
    console.log("hii");
    // setTimeout(function(){
    //   $("#appikon-bis-inline-form-wrapper").removeClass("active");

    // },1000);
    $(".notify-main").hide();
    // $(".btn-div").addClass("active");
  } else {
    console.log("hii1");
    // setTimeout(function(){

    //   $("#appikon-bis-inline-form-wrapper").addClass("active");
    // },1000);

    $(".notify-main").show();
    // $(".btn-div").removeClass("active");
  }
  var d = $("#dimensions-enable").val();
  if (d == true) {
    $(".size-info-ext").each(function () {
      $(this).removeClass();
    });
    $("#ext-" + cvariant.id).addClass("active");
  }

  // $('[data-variant-toggle]').hide(0);
  // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
});

// moment video
// $('.index-product-video-img').click(function(e){
$("body").on("click", ".index-product-video-img", function (e) {
  e.preventDefault();
  console.log("hii");
  $(".video-popup-section").addClass("video-popup-section-active");

  var d = $(this).data("urls");

  var vid = d.split(" - ");
  var h = "";
  $(vid).each(function (i, d) {
    if (d != "" && d.indexOf("mp4") != -1) {
      $("#vid-popup").attr("src", d);
      $("#vid-popup")[0].load();
      $("#vid-popup").trigger("play");
    }
  });
});

$(".video-close-button").click(function () {
  $("#vid-popup").attr("src", "");
  $(".video-popup-section").removeClass("video-popup-section-active");
});
function fixAriaHiddenFocus() {
  // Hide focusable elements in hidden containers
  const focusableSelector = '[aria-hidden="true"] a, [aria-hidden="true"] button, [aria-hidden="true"] input, [aria-hidden="true"] select, [aria-hidden="true"] textarea, [aria-hidden="true"] details summary, [aria-hidden="true"] [tabindex]:not([tabindex="-1"]), [aria-hidden="true"] [contenteditable="true"], [aria-hidden="true"] iframe, [aria-hidden="true"] audio[controls], [aria-hidden="true"] video[controls]';
  document.querySelectorAll(focusableSelector).forEach(el => {
    if (el.hasAttribute('tabindex') && el.getAttribute('tabindex') !== '-1') {
      el.dataset.oldTabindex = el.getAttribute('tabindex');
    }
    el.setAttribute('tabindex', '-1');
  });

  // Restore in visible containers
  const visibleSelector = '[aria-hidden="false"] a, [aria-hidden="false"] button, [aria-hidden="false"] input, [aria-hidden="false"] select, [aria-hidden="false"] textarea, [aria-hidden="false"] details summary, [aria-hidden="false"] [data-old-tabindex], [aria-hidden="false"] [contenteditable="true"], [aria-hidden="false"] iframe, [aria-hidden="false"] audio[controls], [aria-hidden="false"] video[controls]';
  document.querySelectorAll(visibleSelector).forEach(el => {
    if (el.dataset.oldTabindex !== undefined) {
      el.setAttribute('tabindex', el.dataset.oldTabindex);
      delete el.dataset.oldTabindex;
    } else {
      el.removeAttribute('tabindex');
    }
  });
}

// Run immediately
document.addEventListener('DOMContentLoaded', fixAriaHiddenFocus);

// Re-run whenever slider changes
document.addEventListener('t4s:slider:changed', fixAriaHiddenFocus);
document.addEventListener('t4s:slider:resize', fixAriaHiddenFocus);

// Use MutationObserver to catch dynamic aria-hidden changes AND new elements
const ariaObserver = new MutationObserver((mutations) => {
  let shouldRun = false;
  mutations.forEach((mutation) => {
    if (mutation.attributeName === 'aria-hidden' || mutation.type === 'childList') {
      shouldRun = true;
    }
  });
  if (shouldRun) {
    fixAriaHiddenFocus();
  }
});

if (document.body) {
  ariaObserver.observe(document.body, {
    attributes: true,
    subtree: true,
    childList: true,
    attributeFilter: ['aria-hidden']
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    ariaObserver.observe(document.body, {
      attributes: true,
      subtree: true,
      childList: true,
      attributeFilter: ['aria-hidden']
    });
  });
}
